import { Routes, Route, Navigate } from 'react-router-dom';

import { ONBOARDING, PROJECTS, WORKSPACE_URL_REGEX } from '../../constants/routes';
import { useAuth } from '../../context/AuthContext';
import { userRoutes, workspaceRoutes } from './routesArray';
import Error404 from '../../pages/Error/Error404';
import SignedInUserLayout from '../SignedInUserLayout';
import useWorkspaceInvite from '../../context/WorkspaceInviteContext';
import WorkspaceLayout from '../SignedInWorkspaceLayout';
import WorkspaceLogin from '../../pages/Login';

const workspaceRegex = new RegExp(WORKSPACE_URL_REGEX);

const RouteList = () => {
  // constants
  const { isLoggedIn } = useAuth();
  const { isInviteUser } = useWorkspaceInvite();

  // workspace protected routes only accessible if workspace is open and user is logged in
  if (workspaceRegex.test(window.location.host)) {
    return (
      <Routes>
        <Route path="/" element={<Navigate to={`/${PROJECTS}`} />} />
        {workspaceRoutes.map((route) => <Route exact path={route.path} element={<WorkspaceLayout isAllowed={route.isAllowed}>{route.element}</WorkspaceLayout>} key={route.path} />)}
        <Route path="*" element={<WorkspaceLayout isAllowed={[]}><Error404 /></WorkspaceLayout>} />
      </Routes>
    );
  }

  // open routes if not logged in
  if (!isLoggedIn && !isInviteUser) {
    return (
      <Routes>
        <Route path="/" element={<WorkspaceLogin />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  // user protected routes only accessible if user is logged in
  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${ONBOARDING}`} />} />
      {userRoutes.map((route) => <Route exact path={route.path} element={<SignedInUserLayout>{route.element}</SignedInUserLayout>} key={route.path} />)}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default RouteList;
